import { createTheme } from '@material-ui/core/styles'
import { ptBR } from '@material-ui/core/locale'

import typography from './typography'
import palette from './palette'
import overrides from './overrides'
import colors from './colors'

const theme = createTheme(
  {
    colors: { ...colors },
    typography,
    palette,
    overrides,
    zIndex: {
      appBar: 1200,
      drawer: 1100,
    },
    props: {
      MuiTextField: {
        variant: 'outlined',
      },
      MuiPaper: {
        variant: 'outlined',
      },
    },
  },
  ptBR,
)

export default theme
